function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

const SvgSettings = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EF6C00"
    },
    points: "19,28 13,28 13,10.039 13,7.006 14,6.006 18,6.006 19,7.006 19,10.039 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 35,
    style: {
      fill: "#FFE0B2"
    },
    width: 32,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 28,
    style: {
      fill: "#FFE0B2"
    },
    width: 32,
    height: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC80"
    },
    d: "M40.5,22L40.5,22c0.828,0,1.5,0.672,1.5,1.5V40h-3V23.5C39,22.672,39.672,22,40.5,22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC80"
    },
    d: "M7.5,22L7.5,22C8.328,22,9,22.672,9,23.5V40H6V23.5C6,22.672,6.672,22,7.5,22z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 33,
    style: {
      fill: "#FFCC80"
    },
    width: 32,
    height: 2
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757575"
    },
    d: "M24,15H10c-1.105,0-2-0.895-2-2v-2.994c0-1.105,0.895-2,2-2h10.744c0.22,0,0.434,0.072,0.608,0.206 l3.256,2.494C24.855,10.895,25,11.189,25,11.5V14C25,14.552,24.552,15,24,15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78909C"
    },
    d: "M35,19c0,0,5-2,5-6c0-3-3-6-4-6v6c0,0-1,1-2.5,1S31,13,31,13V7c-1,0-4,3-4,6c0,4,5,6,5,6l-1,9h2.5H36 L35,19z"
  }));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSettings, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/settings.4e2cde6b.svg";
export { ForwardRef as ReactComponent };